import React, { useState } from 'react';
import './App.css';
import Login from './components/Login';
import ProductForm from './components/ProductForm';
import ProductList from './components/ProductList';
import Onboarding from './components/Onboarding';
import LandingPage from './components/LandingPage';
import HowItWorks from './components/HowItWorks';
import { ProductProvider } from './context/ProductContext';
import { BrowserRouter, Routes, Route, Navigate, Link } from 'react-router-dom';

function App() {
  const [user, setUser] = useState(null);
  const [isOnboarded, setIsOnboarded] = useState(false);

  const handleLogin = (userData) => {
    setUser(userData);
    setIsOnboarded(false);
  };

  const handleOnboardingComplete = (data) => {
    console.log("Store Data:", data);
    setIsOnboarded(true);
  };

  return (
    <ProductProvider>
      <BrowserRouter>
        <div className="App">
          <nav className="app-navbar">
            <div className="nav-left">
              <Link to="/" className="logo-container">
                <span className="nav-logo-text">TriggerKart</span>
              </Link>

              <div className="nav-links">
                <Link to="/how-it-works" className="nav-link">How It Works</Link>
                {user && isOnboarded && (
                  <>
                    <Link to="/products" className="nav-link">Inventory</Link>
                    <Link to="/add-product" className="nav-link">Add Product</Link>
                  </>
                )}
              </div>
            </div>

            {user && (
              <div className="nav-user-profile">
                <img src={user.picture} alt={user.name} className="nav-avatar" />
                <span className="nav-username">Hi, {user.given_name}</span>
                <button onClick={() => setUser(null)} className="nav-logout-btn">Sign Out</button>
              </div>
            )}
          </nav>

          <main className="main-content">
            <Routes>
              <Route path="/how-it-works" element={<HowItWorks />} />
              <Route path="/*" element={
                !user ? (
                  <LandingPage onLogin={handleLogin} />
                ) : !isOnboarded ? (
                  <Onboarding user={user} onComplete={handleOnboardingComplete} />
                ) : (
                  <Routes>
                    <Route path="/" element={<Navigate to="/products" />} />
                    <Route path="/products" element={<ProductList />} />
                    <Route path="/add-product" element={<ProductForm />} />
                  </Routes>
                )
              } />
            </Routes>
          </main>
        </div>
      </BrowserRouter>
    </ProductProvider>
  );
}

export default App;
